export const isAuthenticated = (chave) => {
  if (!chave) return false;

  return true;
};
